import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import LoadingSpinner from "../LoadingSpinner";

const InputSearchBar = ({
    search,
    search_loading,
    handleSearch,
    handleAutoSearch,
    clear,
    setOpen,
    inputRef: externalInputRef
}) => {

    const localInputRef = useRef(null);
    const inputRef = externalInputRef || localInputRef;
    const [isHover, setIsHover] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isApplePlatform, setIsApplePlatform] = useState(false);

    useEffect(() => {
        if (typeof navigator === "undefined") return;
        const platform =
            navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || "";
        setIsApplePlatform(/mac|iphone|ipad|ipod/i.test(platform));
    }, []);

    //  sort cut Ctrl + K
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();
                setOpen(true);
                inputRef.current?.focus({ preventScroll: true });
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [setOpen]);


    const pathname = usePathname();
    const isBlogPage = pathname.startsWith("/blog");
    const placeholder = isBlogPage
        ? "جستجو در همه بلاگ‌ها ..."
        : "جستجو در محصولات، دسته‌بندی‌ها، برند‌ها";

    return (
        <form
            onClick={() => {
                setOpen(true);
                inputRef.current?.focus({ preventScroll: true });
            }}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onSubmit={handleSearch}
            className="relative w-full max-w-2xl flex items-center bg-jmt-neutral-100 border border-jmt-neutral-100 rounded-lg leading-6 px-2 py-1.5 lg:px-5 lg:py-3 gap-2 cursor-text"
        >

            {search_loading ? (
                <LoadingSpinner size={22} color="#a1a1a1" />
            ) : (
                <Search size={22} className="text-jmt-neutral-400" />
            )}

            <input
                ref={inputRef}
                type="text"
                value={search}
                placeholder={isFocused ? placeholder : "جستجو ..."}
                onFocus={() => {
                    setOpen(true);
                    setIsFocused(true);
                }}
                onBlur={() => { setIsFocused(false); }}
                onChange={handleAutoSearch}
                className="w-full outline-none font-normal text-sm text-jmt-neutral-800 placeholder:text-jmt-neutral-400 placeholder:text-sm"
            />

            {/* Ctrl+K */}
            {isHover && search.length === 0 && (
                <div className="hidden lg:block cursor-pointer absolute left-5 top-1/2 -translate-y-1/2 text-jmt-neutral-600 text-xs p-2">
                    {isApplePlatform ? "K⌘" : "Ctrl + K"}
                </div>
            )}

            {search?.length > 0 && (
                <button
                    type="button"
                    className="absolute top-2 left-2 lg:top-3 lg:left-3 cursor-pointer"
                    onClick={clear}
                >
                    <X className="w-[18px] h-[18px] lg:w-[22px] lg:h-[22px] text-jmt-neutral-400" />
                </button>
            )}
        </form>
    );
};

export default InputSearchBar;
